<template>
  <div>
    <Dropdown
      overlay-class-name="user-ability-wrapper"
      placement="bottomRight"
      :trigger="['click']"
      :align="{ offset: [0, 16] }"
    >
      <div class="userInfoWrap">
        <UserAvatar
          :user-avatar="userInfo.avatar"
          class="meta-avatar"
        />
        <span class="name">{{ userInfo.name }}</span>
      </div>
      <Menu
        @click="handleClickMenu"
        slot="overlay"
        overlay-class-name="dropdown-overlay-menu"
      >
        <MenuItem :key="opsTypes.PROFILE" class="dropdown-menu-item">
          <SvgIcon icon-class="profile" class-name="mr-12" />{{$t('personSetting.PersonalInfo')}}
        </MenuItem>
        <MenuItem :key="opsTypes.UPDATE_PWD" class="dropdown-menu-item">
          <SvgIcon icon-class="account-safety" class-name="mr-12" />{{$t('personSetting.AccountSafety')}}
        </MenuItem>
        <MenuItem :key="opsTypes.RES_SETTING" class="dropdown-menu-item">
          <SvgIcon icon-class="setting" class-name="mr-12" />{{$t('personSetting.GeneralSettings')}}
        </MenuItem>
        <MenuItem :key="opsTypes.ABOUT" class="dropdown-menu-item">
          <SvgIcon icon-class="about" class-name="mr-12" />{{$t('personSetting.About')}}
        </MenuItem>
        <MenuDivider style="margin-bottom: 9px" />
        <MenuItem :key="opsTypes.LOGOUT" class="dropdown-menu-item">
          <SvgIcon icon-class="exit" class-name="mr-12" />{{$t('personSetting.SignOut')}}
        </MenuItem>
      </Menu>
    </Dropdown>
    <PersonalInfo ref="personal_info_modal" />
    <ModifyPassowrdModal v-model="modifyPwdModalVisible" />
    <ResolutionModal v-model="resolutionModalVisible" v-if="resolutionModalVisible"/>
    <AppAbout ref="app_about" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Dropdown, Menu } from 'ant-design-vue'
import UserAvatar from '@/components/business/avatar/UserAvatar.vue'
import SvgIcon from '@/components/behavior/svg-icon/index.vue'
import PersonalInfo from '@/components/business/personal-info-modal'
import { ModifyPassowrdModal } from '@/components/business/safety'
import ResolutionModal from '@/components/business/resolution-modal'
import AppAbout from '@/components/business/app-about-modal'

const OPS_TYPES = Object.freeze({
  PROFILE: 'PROFILE',
  UPDATE_PWD: 'UPDATE_PWD',
  RES_SETTING: 'RESOLUTION_SETTING',
  LOGOUT: 'LOGOUT',
  ABOUT: 'ABOUT'
})

export default {
  name: 'UserAbility',
  components: {
    ResolutionModal,
    UserAvatar,
    Dropdown,
    Menu,
    MenuItem: Menu.Item,
    MenuDivider: Menu.Divider,
    SvgIcon,
    PersonalInfo,
    ModifyPassowrdModal,
    AppAbout
  },
  data() {
    return {
      modifyPwdModalVisible: false,
      resolutionModalVisible: false,
    }
  },
  computed: {
    ...mapState(['userInfo']),
    opsTypes() {
      return OPS_TYPES
    },
  },
  methods: {
    ...mapActions(['doLogout']),
    ...mapActions('user', ['fetchMyPwdStatus']),
    handleClickMenu({ key }) {
      switch (key) {
        case OPS_TYPES.PROFILE:
          this.$refs.personal_info_modal.openModal()
          break
        case OPS_TYPES.UPDATE_PWD:
          this.fetchMyPwdStatus().then(() => {
            this.$nextTick(() => {
              this.modifyPwdModalVisible = true
            })
          }).catch(err => {
            this.$message.error(err.message)
          })
          break
        case OPS_TYPES.RES_SETTING:
          this.resolutionModalVisible = true
          break
        case OPS_TYPES.ABOUT:
          this.$refs.app_about.openModal()
          break
        case OPS_TYPES.LOGOUT:
          this.doLogout()
          break
        default:
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
.user-ability-wrapper {
  & > ul {
    border-radius: 16px;
    overflow: hidden;
  }
  .dropdown-overlay-menu {
    width: 186px;
    height: 190px;
    background: #ffffff;
    box-shadow: 0px 5px 30px 0px rgba(89, 132, 219, 0.08);
    border-radius: 16px;
    border: 1px solid #edeff2;
  }
  .dropdown-menu-item {
    .regular-font(16);
    color: #333;
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    margin: 2px 8px;
    width: 170px;
    padding: 0 0 0 8px;
    &:hover {
      background: #f3f6fb;
    }
  }

}
.meta-avatar {
  height: 42px;width: 42px; border-radius: 50%; cursor: pointer
}
.userInfoWrap {
  display: flex;
  align-items: center;
  .name{
    margin-left: 10px;
    color: #1890ff;
    cursor: pointer;
  }
}
</style>
